'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.page-header {\n  top: 55px;\n  position: fixed;\n  background-color: #00b9f7;\n  height: 50px;\n  max-height: 50px;\n  min-height: 50px;\n  color: white;\n  width: 100%;\n  margin: 0;\n  border-bottom: 0;\n  z-index: 10;\n}\n\n.menu {\n  padding: 0 30px;\n  display: inline-block;\n}\n\n.page-title {\n  display: inline-block;\n}\n\n.page-header h1 {\n  line-height: 50px;\n  margin-top: 0;\n  color: white;\n}\n\n.view-header-primary-sport.NFL {\n    color: #37b346;\n}\n.view-header-primary-sport.NBA {\n    color: #c08320;\n}\n.view-header-primary-sport.MLB {\n    color: #f01621;\n}\n.view-header-primary-sport.NHL {\n    color: #12c6c8;\n}\n.view-header-primary-sport.PGA {\n    color: #3c9369;\n}\n.view-header-primary-title {\n    background-color: #00b9f7;\n    color: #fff;\n    padding: 0 20px;\n}\n.view-header-primary-sport {\n    background-color: #f6f6f6;\n    height: 50px;\n    padding: 12px 20px 0 20px;\n}\n.view-header-primary-sport, .view-header-primary-title {\n    display: inline-block;\n    font-size: 21px;\n    border-right: 1px solid hsla(0,0%,100%,.5);\n    letter-spacing: 0.1px;\n    margin: 0;\n}\n';

var PageHeader = function PageHeader(props) {
    var handleSourceChange = props.handleSourceChange;
    var sourceId = props.sourceId;
    if (sourceId === undefined) {
        sourceId = 4;
    }
    var spanClass = 'view-header-primary-sport ' + props.sport.toUpperCase();

    var slateOptions = '';
    if (props.slatesForSource.length > 0) {
        slateOptions = _react2.default.createElement(
            'select',
            { value: props.viewSlate, onChange: props.handleSlateChange, id: 'select-slate' },
            _react2.default.createElement(
                'option',
                { value: '0' },
                'Select a slate'
            ),
            props.slatesForSource.map(function (slate, idx) {
                var slateDisplay = (0, _moment2.default)(slate.contest_start_date).format('h:mm A') + ' (' + slate.game_count + ' games) ' + slate.contest_suffix;
                var thisKey = slate.id + '-' + idx;
                return _react2.default.createElement(
                    'option',
                    { key: thisKey, value: slate.id },
                    slateDisplay
                );
            })
        );
    }

    var display = _react2.default.createElement(
        'div',
        { className: 'page-header' },
        _react2.default.createElement(_reactCssComponent.ClientStyle, { css: css }),
        _react2.default.createElement(
            'div',
            { className: spanClass },
            props.sport.toUpperCase()
        ),
        _react2.default.createElement(
            'a',
            { href: props.returnURL },
            _react2.default.createElement(
                'h1',
                { className: 'view-header-primary-title' },
                props.title
            )
        ),
        _react2.default.createElement(
            'nav',
            { className: 'page-header-nav center' },
            _react2.default.createElement(
                'ul',
                { className: props.displaySources ? 'tabs' : 'hide' },
                props.sources.map(function (source) {
                    if (source.id === 3 || source.id === 4) {
                        return _react2.default.createElement(
                            'li',
                            { key: source.id },
                            _react2.default.createElement(
                                'a',
                                {
                                    onClick: function onClick() {
                                        return handleSourceChange(source.id);
                                    },
                                    className: +sourceId === source.id ? 'active' : ''
                                },
                                source.display_name
                            )
                        );
                    }
                    return null;
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '0 20px' } },
            _react2.default.createElement(_reactDatepicker2.default, {
                id: 'select-date',
                selected: props.fromDate,
                onChange: props.handleDateChange,
                className: 'form-control-datepicker'
            })
        ),
        _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', minWidth: '160px' } },
            slateOptions
        )
    );

    return display;
};

exports.default = PageHeader;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/navigation-condensed/PageHeader.js
// module id = 852
// module chunks = 0